import { defaultDictionary, TranslationKey } from '@/translations';

export function isTranslationKey(key: string): key is TranslationKey {
    return key in defaultDictionary;
}
